/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=70c90be1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c90be1"]])

export default __exports__